export default __webpack_public_path__ + "static/media/ingame-wr.830edb2c.png";